import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type ExpenseMileageConfiguration } from '@webapp/modules/expense/entities'
import messages from './messages'
import { useQueryExpenseMileageConfiguration } from '../../models/useQueryExpenseMileageConfiguration'

interface UseGetExpenseMileageConfigurationPresenterReturn {
  data: {
    configuration: Nullable<ExpenseMileageConfiguration>
  }
  states: {
    isLoading: boolean
    isFetching: boolean
  }
}

export const useGetExpenseMileageConfigurationPresenter = ({
  enabled = true,
}: {
  enabled?: boolean
} = {}): UseGetExpenseMileageConfigurationPresenterReturn => {
  const intl = useProcurifyIntl()

  const onLoadError = (err: unknown) => {
    toast.error({
      title: intl.formatMessage(messages.loadErrorToastTitle),
      children:
        getMessageFromError(err) ||
        intl.formatMessage(messages.loadErrorToastMessage),
    })
  }

  const { configuration, isLoading, isFetching } =
    useQueryExpenseMileageConfiguration({ onError: onLoadError, enabled })

  return {
    data: { configuration },
    states: { isLoading, isFetching },
  }
}
